import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle, Modal, Form, Container, Button, Alert, UncontrolledTooltip, Table, UncontrolledDropdown, DropdownToggle, DropdownMenu } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Link, useHistory, useParams } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate, downloadBase64File } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader'

    const LeaveRequestDetails = () => {

        const history = useHistory();
        const {id} = useParams();

        const [lR, setLR] = useState({})
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [gender, setGender] = useState('');
        const [hrManagerNo, setHRManagerNo] = useState('');
        const [leaveNo, setLeaveNo] = useState('');
        const [supervisorNo, setSupervisorNo] = useState('');
        const [supervisorName, setSupervisorName] = useState('');
        const [leaveCategory, setLeaveCategory] = useState('');
        const [startDate, setStartDate] = useState(new Date());
        const [endDate, setEndDate] = useState(new Date());
        const [leaveStatus, setLeaveStatus] = useState('');
        const [st, setSt] = useState('danger');
        const [hrManagerName, setHRManagerName] = useState('');
        const [departmentCode, setDepartmentCode] = useState('');
        const [postingDate, setPostingDate] = useState('');
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [selectedDates, setSelectedDates] = useState([new Date(), new Date()])
        const [leaveRequestLines, setLeaveRequestLines] = useState([])
        const [selectedFile, setSelectedFile] = useState([])
        const [loadingFiles, setLoadingFiles] = useState(false)

        const [CompanyID, setCompanyID] = useState("")

        const [modal_line, setmodal_line] = useState(false)
        const [modal_comments, setmodal_comments] = useState(false);
        const [approvalCommentLines, setApprovalCommentLines] = useState([])

        const [cCode, setCCode] = useState('')
        const [causesofabsence, setCausesofAbsence] = useState([])
        const [documentID, setDocumentID] = useState('')
        const [isEdit, setIsEdit] = useState(false)
        const [quantity, setQuantity] = useState(0)
        const [description, setDescription] = useState('')
        const [lineSystemID, setLineSystemId] = useState('')
        const [selectedType, setSelectedType] = useState('')

        toastr.options = TOAST_OPTIONS;
        const [inputs, setInputs] = useState([]);
        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_line = () => {
            setmodal_line(!modal_line);
            removeBodyCss();
        }
        const tog_comments = () => {
            setmodal_comments(!modal_comments);
            removeBodyCss();
        }
        const handleSubmit = (event) => {
            event.preventDefault();
            toastr.success("Leave Request No  created" ); 
        }
        const addLine = () =>{
            setIsEdit(false)
            tog_line()
            setCCode('')
            setSelectedDates(null) 
        }
        const handleDeleteLine2 = (k) =>{
            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
              }
            axios.delete(`${url.LEAVE_REQUEST_LINES}(${lineSystemID})?company=${CompanyID}`, Config).then((r)=>{
                setIsloading(false)
                toastr.success('Leave request line deleted successfully')
                tog_line(false)
                fetchData()
                clearLineData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
      }
   
        const handleCancelApprovalRequest = (e) => {
            setIsloading(true)
            const lNo = {'no': leaveNo}
            axios.post(url.CANCEL_APPROVAL_REQUEST+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success("Approval Request Cancelled" ); 
                        history.go(0)
                    }else{
                        toastr.success("Could not Cancel Approval Request" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                    setIsloading(false)
            })
        }
        const handleApprovalRequest = (e) => {
            setIsloading(true)
            const lNo = {'no': leaveNo}
            axios.post(url.SEND_LR_APPROVAL_REQUEST+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success("Leave Request Sent For Approval" ); 
                        history.go(0)
                    }else{
                        toastr.success("Could not Send leave request for approval" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setIsloading(false)
                    console.log(error)
            })

        }
        const handleDeleteLeaveRequest = () =>{
            setIsloading(true)
            const lNo = {'no': leaveNo}
            axios.post(url.DELETERECORD+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success(response.data.value ); 
                        history.push("/leave-requests")
                    }else{
                        toastr.warning("Could not Delete leave request" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setIsloading(false)
                    console.log(error)
            })

        }
        const handleEditLine = (k) =>{
            setLineSystemId(leaveRequestLines[k].SystemId)
            setIsEdit(true)
            tog_line()
            setCCode(leaveRequestLines[k].Leave_Type)
            setSelectedDates([new Date(leaveRequestLines[k].Start_Date), new Date(leaveRequestLines[k].Return_Date)]) 
            setQuantity(leaveRequestLines[k].Quantity)
            setDescription(leaveRequestLines[k].Description)
        }
        const clearLineData = () =>{
            setCCode('');
            setSelectedDates(null)
            setLineSystemId('')
        }
        const handleAddLine2 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            const data = {
                DocumentNo          :   leaveNo,
                HRM_Document_Type   :   'Absence',
                Leave_Type          :   cCode,
                Start_Date          :   formatDate(selectedDates[0]) ,
                Return_Date         :   formatDate(selectedDates[1]) ,
            }
            axios.post(`${url.LEAVE_REQUEST_LINES}?company='${CompanyID}'`, JSON.stringify(data), Config).then((r)=>{
                if(r.request.status == '201'){
                    toastr.success("Leave Request No: "+ r.data.DocumentNo+" updated successfully" ); 
                    tog_line(false)
                    fetchData()
                    clearLineData()
                }else{
                    toastr.error("Could not update leave request" )
                }
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
      }
        const handleUpdateLine2 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            const data = {
              Leave_Type    :cCode,
              Start_Date    :formatDate(selectedDates[0]) ,
              Return_Date   :formatDate(selectedDates[1]) ,
            }
            axios.patch(`${url.LEAVE_REQUEST_LINES}(${lineSystemID})?company=${CompanyID}`, JSON.stringify(data), Config).then(function(response){
                if(response.request.status == '200'){
                    toastr.success("Leave Request No: "+ response.data.DocumentNo+" updated successfully" ); 
                    tog_line(false)
                    fetchData()
                    clearLineData()
                }else{
                    toastr.error("Could not update leave request" )
                }
                setIsloading(false)
            }).catch(function (error){
                console.log(error)
                toastr.error(error.response.data.error.message);
                setIsloading(false)
            })
      }
        const fetchData = () =>{
            let obj = JSON.parse(localStorage.getItem("authMildUser"));
            let EmployeeNo = obj.uid;
            setCompanyID(obj.activeCompany);
            setIsloading(true)
            axios.get(url.LEAVE_REQUESTS + "("+ id +")?$expand=leaveRequestLines" + "&company="+ obj.activeCompany, HRConfig)
                .then(function(response){
                    setLR(response.data);
                    setEmpNo(response.data.employeeNo);
                    setEmpName(response.data.employeeName);
                    setLeaveNo(response.data.no);
                    setLoadingFiles(true)
                    // axios.get(`${url.ATTACHDOCUMENTS}?$filter=No eq '${response.data.No}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{
                    //     setSelectedFile(r.data.value)
                    //     setLoadingFiles(false)
                    // }).catch((e)=>{ console.log(e); setLoadingFiles(false) })

                    axios.get(`${url.EMPLOYEES2}?$filter=No eq '${response.data.employeeNo}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{
                        setEmpTitle(r.data.value[0].JobTitle);
                        setGender(r.data.value[0].Gender);
                        setIsloading
                    }).catch((e)=>{ console.log(e); setIsloading(false) })

                    axios.get(url.CAUSES_OF_ABSENCE +"?company="+ obj.activeCompany, HRConfig).then((r)=>{ 
                        setCausesofAbsence(r.data.value);
                    }).catch((e)=>{
                        console.log(e) 
                    })

                    setSupervisorNo(response.data.supervisorNo);
                    setLeaveStatus(response.data.status);
                    setStartDate(response.data.From_Date);
                    setEndDate(response.data.To_Date);
                    setSupervisorName(response.data.supervisorName);
                    setHRManagerNo(response.data.hRManagerNo);
                    setHRManagerName(response.data.hRManagerName);
                    setDepartmentCode(response.data.departmentCode);
                    setSelectedDates([ new Date(response.data.From_Date), new Date(response.data.To_Date)])
                    setPostingDate(response.data.postingDate);
                    setLeaveRequestLines(response.data.leaveRequestLines)
                    if(leaveStatus == 'Pending'){
                        setSt('warning');
                    }else if(leaveStatus == 'Approved'){
                        setSt('success');
                    }else{
                        setSt('danger');
                    }
                    setIsloading(false)
                    setUserError(false);

                    axios.get(`${url.APPROVALCOMMENTS}?$filter=document_Type eq 'Payment Requisition' and document_No eq '${r.data.no}' &company=${obj.activeCompany}`, HRConfig).then((r)=>{
                        setApprovalCommentLines(r.data.value)
                    })
                }).catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setUserError(true);
                    setIsloading(false)
                })
        }
        useEffect(() => {
            fetchData()
        },[]);
       
        const handleDownload = (clickedFile) => {
            const base64String = clickedFile.FileContentsBase64;
            const fileName = clickedFile.FileName;
            const fileExtension = clickedFile.FileExtension;
            const contentType = clickedFile.fileContentType;
            downloadBase64File(base64String, fileName, fileExtension, contentType);
        }
        const handleComments = () =>{
            setIsEdit(false)
            setIsloading(true)
            tog_comments()
            setIsloading(false)
        }
        const removeFile = (clickedFile) =>{ 
            const Config = {
                auth: {
                  username: url.HRMIS,
                  password: url.HRMISPASS,
                },
                headers: {
                  'Content-Type': 'application/json',
                  'If-Match'    : '*'
                }
            }
            setIsloading(true)
            axios.delete(`${url.ATTACHDOCUMENTS}(${clickedFile.SystemId})`, Config).then((r)=>{
                toastr.warning('File deleted')
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Leave Request Details | {url.APPNAME}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={`Human Resource Management`} breadcrumbItem={`Leave Request Details`} />
                        <Form onSubmit={handleSubmit}>
                    
                            <Alert color={`${st}`} role="alert">
                                    <strong>{leaveStatus}</strong>
                            </Alert>
           
                        <Row>
                        <Col xl={4}>
                        <Card>
                            <CardBody>
                                <CardTitle>Employee Details</CardTitle>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <th scope="col"> Number</th>
                                                    <td scope="col"> {empNo} </td>
                                                </tr>
                                                <tr>
                                                    <th scope="col"> Name</th>
                                                    <td scope="col">{empName}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="col">Position</th>
                                                    <td scope="col">{empTitle}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Gender</th>
                                                    <td>{gender}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>

                            <div className="d-flex">
                                <div className="flex-grow-1 ms-1">                                 
                                    <ul className="list-unstyled vstack gap-2 mb-0">
                                        <div className="d-grid gap-2">
                                            {(leaveStatus == 'Open') && (
                                            <Button color="warning" 
                                                type="button" 
                                                className="btn btnSubmitPlan" 
                                                onClick={()=>{addLine()}} >
                                                {/* onClick={()=>{tog_line()}} > */}
                                                <i className="mdi mdi-calendar-edit"/>{" "}
                                                    Add Leave Request Line
                                            </Button>
                                            )}
                                            {(leaveStatus == 'Open') && (
                                            <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={()=>{handleDeleteLeaveRequest()}} >
                                                <i className="mdi mdi-delete"/>{" "}
                                                    Delete Leave Request
                                            </Button>
                                            )}
                                            {(leaveRequestLines.length > 0) && (leaveStatus == 'Open') && (
                                            <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={handleApprovalRequest}>
                                                <i className="mdi mdi-clipboard-check-outline"/>{" "}
                                                    Submit Leave Request for Approval
                                            </Button>
                                            )}
                                            {(leaveStatus == 'Pending') && (
                                            <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={handleCancelApprovalRequest}>
                                                <i className="mdi mdi-book-cancel-outline"/>{" "}
                                                    Cancel Approval Request
                                            </Button>
                                            )}
                                            {(approvalCommentLines.length > 0) && (
                                                    <Button color="info" type="button" className="btn btnSubmitPlan" onClick={handleComments}>
                                                        <i className="mdi mdi-calendar-edit"/>{" "}
                                                            View Rejection Comments
                                                    </Button>
                                                )}
                                        </div>
                                    </ul>
                                </div>
                            </div>
                            </Col>
                            <Col  xl={8}>
                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-3">
                                        Leave Request Details
                                    </CardTitle>
                                    <div className="table-responsive">
                                        <Row>
                                            <Col md={5}>
                                                <table className="table">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="col"> Request Number</th>
                                                            <td scope="col"> {leaveNo} </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col"> Posting Date</th>
                                                            <td scope="col">{postingDate}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Department Code</th>
                                                            <td scope="col">{departmentCode}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Status</th>
                                                            <td>{leaveStatus}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Col>
                                            <Col md={7}>
                                                <table className="table">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="col"> Supervisor No</th>
                                                            <td scope="col"> {supervisorNo} </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col"> Supervisor Name</th>
                                                            <td scope="col">{supervisorName}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">HR Manager No</th>
                                                            <td scope="col">{hrManagerNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">HR Manager Name</th>
                                                            <td scope="col">{hrManagerName}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Col>
                                        </Row>
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <CardTitle className= "mb-3 mt-1 justify-content-center">
                                        Leave Request Lines ({leaveRequestLines.length})
                                    </CardTitle>
                                    <CardBody className="border-bottom">
                                        {(leaveRequestLines.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table  className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Leave Type</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Start Date</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>End Date</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Quantity</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Description</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {leaveRequestLines.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Leave_Type}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Start_Date}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Return_Date}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Quantity}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.Description}</td> 
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> 
                                                                
                                                                {(leaveStatus == 'Open') && (
                                                                    <div className="d-flex gap-3"> 
                                                                        <Link
                                                                            to="#"
                                                                            className="text-primary"
                                                                            onClick={() =>{handleEditLine(k)}}
                                                                        >
                                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                                            <UncontrolledTooltip placement="top" target="edittooltip">
                                                                                Edit
                                                                            </UncontrolledTooltip>
                                                                        </Link>   
                                                                        <Link
                                                                            to="#"
                                                                            className="text-danger"
                                                                            onClick={() => handleRemoveItem(k)}
                                                                        >
                                                                        {/* <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                                Delete
                                                                            </UncontrolledTooltip> */}
                                                                        </Link>
                                                                    </div>
                                                                )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        ):(
                                            <div className="text-center">
                                                <div className="mb-4">
                                                    <i className="mdi mdi-calendar-edit text-warning display-4" />
                                                </div>
                                                <div>
                                                    <h5>No Leave Request Lines added, yet!</h5>
                                                </div>
                                            </div>
                                        )}
                                    </CardBody>

                                    <Modal isOpen={modal_line} toggle={() => { tog_line(); }}  size="l" centered  backdrop={'static'}  >
                                        <div className="modal-header">
                                            <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update/Delete `:`Add ` }Leave Request Line</h5>
                                            <button type="button"  onClick={() => { setmodal_line(false) }}  className="close" data-dismiss="modal"aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <Row>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <label htmlFor="floatingIdInput">Leave Type</label>
                                                        <select className="form-select" value={cCode} onChange={(e)=>setCCode(e.target.value)}>
                                                            <option value=""></option>
                                                            {causesofabsence.map((c,k)=>(
                                                                <option key={k} value={c.Code}>{c.Description}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <label htmlFor="floatingDepartInput">Start Date - End Date</label>
                                                        <Flatpickr
                                                            className="form-control"
                                                            placeholder="dd M,yyyy"
                                                            options={{
                                                                mode: "range",
                                                                dateFormat: "Y-m-d"
                                                            }}
                                                            value={selectedDates}
                                                            onChange={(dates) =>{setSelectedDates(dates)} }
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        
                                        <div className="modal-footer justify-content-center">
                                            {isEdit && (isloading ? 
                                                (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                                : ( <button type="button" className="btn btn-primary" onClick={()=>handleUpdateLine2()}>
                                                 <i className="mdi mdi-pencil" id="edittooltip" />{" "}Update line details...</button> ))
                                            }
                                            {!isEdit && (isloading ? 
                                                (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                                : ( <button type="button" className="btn btn-success" onClick={()=>handleAddLine2()}>Save line details...</button> ))
                                            }
                                            {isEdit && (isloading ? 
                                                (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                                : ( <button type="button" className="btn btn-danger" onClick={()=>handleDeleteLine2()}>
                                                <i className="mdi mdi-delete" id="deletetooltip" />{" "}Delete line...</button> ))
                                            }
                                        </div>
                                </Modal>

                                <Modal isOpen={modal_comments} toggle={() => { tog_comments() }} centered size="xl">
                                    <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Rejection Comments</h5>
                                        <button
                                        type="button"
                                        onClick={() => {
                                            setmodal_comments(false);
                                        }}
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        >
                                        <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">                                                       
                                    <Row >
                                        <Col lg={12}>
                                        {(approvalCommentLines.length > 0) ? (
                                            <div className="table-responsive">
                                            <Table className="table table-sm m-0">
                                                <thead>
                                                <tr>
                                                    <th>Document No.</th>
                                                    <th>Comment</th>
                                                    <th>Rejected by</th>
                                                    <th>Rejection Date/Time</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    {approvalCommentLines.map((a,k)=>(
                                                        <tr key={k}>
                                                            <td>{a.document_No}</td>
                                                            <td>{a.Comment}</td>
                                                            <td>{a.rejected_By}</td>
                                                            <td>{a.rejected_Date_Time}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                            </div>
                                        ):(
                                            <div className="text-center">
                                                <div className="mb-4">
                                                <i className="mdi mdi-school-outline text-warning display-4" />
                                                </div>
                                                <div>
                                                <h5>No rejection comments found</h5>
                                                <p className="text-muted">
                                                        
                                                </p>
                                                </div>
                                            </div>
                                        )}
                                        </Col>
                                    </Row>            
                                </div>
                                </Modal>  
                            </CardBody> 
                        </Card>

                                    

                            {/* <Card>
                                <CardBody>
                                    <CardTitle>Attachments</CardTitle>
                                    {loadingFiles ? (
                                        <>
                                        <div className="text-center">
                                                    <div className="mb-4">
                                                    </div>
                                                    <div>
                                                    <h5>Loading attached files please wait ...</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                        </>
                                    ): ((selectedFile.length > 0)?(
                                        <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>File</th>
                                                            
                                                            <th></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {selectedFile.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{k+1}</td>
                                                                <td>
                                                                
                                                                <Link to="#" onClick={()=>handleDownload(selectedFile[k])}>{a.FileName}</Link></td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> <>
                                                                
                                                                    <div className="d-flex gap-3">
                                                                    {(leaveStatus == 'Open') && (
                                                                        <Link
                                                                        to="#"
                                                                        className="text-danger"
                                                                        onClick={() => removeFile(selectedFile[k])}
                                                                        >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                        </Link>
                                                                        )}
                                                                    </div>
                                                               
                                                                    </></td>
                                                               
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No file attached</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            ))}
                            
                                </CardBody>
                            </Card> */}
                                                                        
                    
                        </Col>
                        </Row>
                        </Form>


                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default LeaveRequestDetails;